import { AjaxConfig, OptionsData, OptionsPagination } from 'tabulator-tables'; //import Tabulator library
import { SpinnerWrapper } from '../Spinner/spinnerWrapper';
import { tabulatorInstance } from './tabulatorInstance';
import { IResponse, ITabulatorLoader } from './types';
import HttpStatusCode from '../../../data/fetch/HttpStatusCode';
import { debugLog } from '../../../utils/Logger';

export type AjaxObj = {
	abortController: AbortController;
	element: HTMLElement;
	spinner: SpinnerWrapper;
};


export const ajaxLoader = (ajaxObj: AjaxObj, props: ITabulatorLoader, token?: string): OptionsData & OptionsPagination => {
	let pageCookie: string | undefined = undefined; 
	const spinner = ajaxObj.spinner;

	const parseQueryParams = (params: Record<string, string | number | undefined>): string => {
		let query = "";

		for (const param in params) {
			const value = params[param];
			if (value) {
				query += `${query[0] ? "&" : ""}${param}=${value}`;
			}
		}
		return query;
	};

	const appendQueryParams = (url: string, params: Record<string, string | number | undefined>): string => {
		const query = parseQueryParams(params);
		if (query) {
			if (url) {
				return `${url}${url.indexOf("?") > 0 ? "&" : "?"}${query}`;
			} else {
				return query;
			}
		}
		return url;
	};

	const ajaxRequesting = (url: string) => {
		return ajaxObj.abortController.signal.aborted || !url ? false : true;
	};

	const ajaxRequestFunc = async (url: string, config: RequestInit, params: Record<string, string | number>): Promise<IResponse> => {
		if ((params.page as number) <= 1) {
			pageCookie = undefined;
			spinner.show(ajaxObj.element);
		}
		try {
			if (tabulatorInstance.defaults.ajaxRequestFunc) {
				return tabulatorInstance.defaults.ajaxRequestFunc(url, config, params);
			} else {
				url = appendQueryParams(url, {
					pageSize: params.pageSize,
					pageCookie
				});

				let response: IResponse = { data: undefined, status: 500 };

				debugLog(`#Tabulator GET: `, url, " Params: ", params );
				if (tabulatorInstance.defaults.ajaxFetch) {
					response = await tabulatorInstance.defaults.ajaxFetch(url, params, ajaxObj.abortController.signal);
				} else {
					url = appendQueryParams(url, params);
					const result = await fetch(url, { ...config, signal: ajaxObj.abortController.signal });
					response.status = result.status;
					response.data = await result.json();
				}

				let data: unknown[] = [];
				let total_pages = params.page;

				if (response.status >= HttpStatusCode.OK && response.status < HttpStatusCode.MULTIPLE_CHOICES) {
					const result = response.data as any; //ajaxPaginationResponse(response);
					if (result) {
						data = result.Data as unknown[];
						pageCookie = result.PageCookie;
						if (ajaxObj.abortController.signal.aborted) {
							result.totalPages = result.page;
						}
						if (props.responseToData) {
							data = props.responseToData(data);
						}
					} else {
						pageCookie = undefined;
					}
					total_pages = +params.page + (pageCookie ? 10 : 0);
				}
				if (props.onLoadFinished) {
					props.onLoadFinished(data);
				}
				return { page: +params.page, pageSize: +params.page_size, totalPages: +total_pages, status: response.status, data };
			}
		} finally {
			spinner.hide();
		}
	};

	const paginationSize = props.paginationSize || 200;
	return {
		dataLoader: true,
		progressiveLoad: paginationSize ? "scroll" : undefined,
		progressiveLoadScrollMargin: 200,
		ajaxConfig: tabulatorInstance.defaults.ajaxConfig as AjaxConfig,
		ajaxRequesting,
		ajaxRequestFunc,
		paginationSize,
		dataSendParams: tabulatorInstance.defaults.dataSendParams,
		dataReceiveParams: tabulatorInstance.defaults.dataReceiveParams,
	};
};

/*
export const onAjaxError = (xhr: any): void => {
	console.debug(`${colors.green}Tabulator${colors.reset} Response Error:`, xhr.message);
	if (props.onLoadFinished) {
		props.onLoadFinished(undefined, xhr.message);
	}
	//console.error('ajaxError: ' + xhr.message );
}*/
